import script from "./char.vue?vue&type=script&setup=true&lang=js"
export * from "./char.vue?vue&type=script&setup=true&lang=js"

import "./char.vue?vue&type=style&index=0&id=71e947f0&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e947f0"]])

export default __exports__